export default __webpack_public_path__ + "static/media/fifa-logo.69bde69c.webp";